module.exports = __webpack_public_path__ + "img/f7.05587f83.jpg";